import { DadosCadastrais } from '../atoms/forms/DadosCadastrais'
import DSRSection from '../atoms/forms/DSRSection'
import EmpresaPontoForm from '../atoms/forms/EmpresaPontoForm'
import OutrosDados from '../atoms/forms/OutrosDados'

export const tabs = [
    {
        name: 'empresa',
        label: 'Cadastro',
        content: <DadosCadastrais />,
    },
    {
        name: 'ponto',
        label: 'Ponto',
        content: <EmpresaPontoForm />,
    },
    {
        name: 'dsr',
        label: 'DSR',
        content: <DSRSection />,
    },
    {
        name: 'outros',
        label: 'Outros',
        content: <OutrosDados />,
    },
]
